import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["rows"];

  addRow(event) {
    event.preventDefault();
    const row = document.createElement("tr");
    row.innerHTML = `
      <td><input type="text" name="organization[pronunciation_words][]" class="form-control"></td>
      <td><input type="text" name="organization[pronunciation_phonemes][]" class="form-control"></td>
      <td><a href="#" data-action="click->pronunciation-lexicon#removeRow">remove</a></td>
    `;
    this.rowsTarget.appendChild(row);
  }

  removeRow(event) {
    event.preventDefault();
    event.target.closest("tr").remove();
  }
}
